<template>
  <div class='mt-1'>
    <OrientationVideos
      :orientationVideos="orientationVideos"
      :agent="agent"
      @clear="orientationVideos = []"
    />
    <b-overlay
      :show='loading'
      rounded
      no-center
      opacity='0.6'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
    >
    <table class='text-center table b-table table-bordered custom-table'>
      <thead class='sticky'>
        <tr>
          <th colspan='4' class='container-tab-buttons'>
            <tab-buttons />
          </th>
        </tr>
      </thead>
    </table>

    <!-- ============ AGENTES SEM VÍNCULO DE PRODUTO OU CARGO ============ -->
    <section
      v-show='agentsWithoutProduct && agentsWithoutProduct.length > 0'
      v-for='agentWithoutProduct in agentsWithoutProduct'
      :key='agentWithoutProduct._id'
      class='mt-1'
    >
      <!-- ============ RISCOS QUÍMICOS ============ -->
      <section v-if="agentWithoutProduct.riskType === 'quimico'">
        <section class='risk-chemical d-flex align-items-center justify-content-center pt-3 text-center w-100'>
          <h6><strong>Agentes pesquisados sem vínculo de produto ou cargo.</strong></h6>
        </section>
        <section class='risk-chemical d-flex align-items-center justify-content-between margin-top-2 px-3 py-2'>
          <section>
            <strong class='risk-text'>Riscos Químicos</strong>
          </section>
          <section>
            <button class='btn-expand-collapse-navy-blue' @click="toggleChemicalExpanded('tabPcmsoChemicalRiskOpenAgentsWithoutProductAffiliation')">
              {{ userPreferences && userPreferences.tabPcmsoChemicalRiskOpenAgentsWithoutProductAffiliation ? 'Recolher informações' : 'Expandir informações' }}
            </button>
          </section>
        </section>
        <section class="margin-left-25">
          <table
            v-if='userPreferences && userPreferences.tabPcmsoChemicalRiskOpenAgentsWithoutProductAffiliation'
            class='text-center table b-table table-bordered custom-table margin-top-1'
          >
            <thead>
              <tr class='header-table-chemical'>
                <th class='width-40-percent'>CAS: Agente</th>
                <th class='width-30-percent'>Origem da informação</th>
                <th class='width-30-percent'>Dados do Exame Complementar</th>
              </tr>
            </thead>

            <tbody>
            <template v-for='item in agentWithoutProduct.legalSearches'>
              <template v-if='item.board_01 || item.board_02 || item.complementaryExamsAcgih'>
                <tr v-for='(row, i) in model.getList(item)' :key='`chem_row_${row}_${item.legalSearchId || item.cas}`'>
                  <td v-if='i === 0' :rowspan='model.getList(item).length'>
                    <div>
                      <b-tooltip
                        :target='`chem_${item.cas}_${item.legalSearchId}`'
                        custom-class="custom-tooltip"
                        placement='auto'
                        triggers='hover'
                      >
                        <section
                          v-if='(item.attachment11 && item.attachment11.group) || item.nameAttachment11'
                        >
                          <span class='p-2 text-white' style='font-size: 15px'>
                            Este agente consta na NR 15 com o seguinte nome:
                            {{ item.attachment11 && item.attachment11.group
                              ? item.attachment11.group
                              : item.nameAttachment11 ? item.nameAttachment11: '-' }}
                          </span> <br/><br/>
                        </section>

                        <section class='p-2' v-if='item.acgih && item.agent'>
                          <span class='text-white' style='font-size: 15px'>
                            Este agente já foi citado na ACGIH com o nome:
                            {{ item.agent ? item.agent : '-' }}
                          </span>
                          <br/><br/>
                        </section>

                        <a
                          :href='`https://pubchem.ncbi.nlm.nih.gov/#query=${item.cas}`'
                          target='_blank'
                          class='link-pubchem-cas ml-2'
                        >
                          <span>
                            Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{item.cas}}
                          </span>
                        </a>
                      </b-tooltip>

                      <a href='#' class='hover_links' :id='`chem_${item.cas}_${item.legalSearchId}`'>
                        <span class='word-break'>{{ model.getsearchId(item) }}</span>
                        <b-icon
                          style='margin-bottom: -1px'
                          class='ml-1'
                          font-scale="1.2"
                          icon="info-circle-fill"
                          variant="info"
                        >
                        </b-icon>
                      </a>

                      <section v-if='item.videosOrientacaoAbaPcmso && item.videosOrientacaoAbaPcmso.length > 0'>
                        <button
                          class='btn-orientations mt-2'
                          @click='showModalOrientationVideos(model.getsearchId(item), item.videosOrientacaoAbaLaudoInsalubridade)'
                        >
                          <span>Ver orientações <br/> especificas</span>
                        </button>
                      </section>
                    </div>
                  </td>
                  <td>
                    <div v-if='item.board_01 && row === board_01'>NR 7 - Quadro 1</div>
                    <div v-if='item.board_02 && row === board_02'>NR 7 - Quadro 2</div>
                    <div v-if='item.complementaryExamsAcgih && row === complementaryExamsAcgih'>ACGIH 2024</div>
                  </td>
                  <td>
                    <div v-if='item.board_01 && row === board_01'>
                      <div
                        class='mt-3'
                        :class="indicatorsIndex < item.board_01.indicators.length - 1 ? 'border-supplementaryExamData':''"
                        v-for='(indicator, indicatorsIndex) in item.board_01.indicators' :key='indicatorsIndex'
                      >
                        <p>
                          Indicador: {{ indicator[`indicator_0${(indicatorsIndex + 1)}`].join(', ') }} <br />
                          Momento da coleta: {{ indicator.timeOfCollection }}<br />
                          Valor do IBE/EE: {{ indicator.valueIbeEE }}<br />
                          Observações: {{ indicator.observation }}<br />
                        </p>
                      </div>
                    </div>

                    <div v-if='item.board_02 && row === board_02'>
                      <div
                        class='mt-3'
                        :class="indicatorsIndex < item.board_02.indicators.length - 1 ? 'border-supplementaryExamData':''"
                        v-for='(indicator, indicatorsIndex) in item.board_02.indicators' :key='indicatorsIndex'
                      >
                        <p>
                          Indicador: {{ indicator[`indicator_0${(indicatorsIndex + 1)}`].join(', ') }} <br />
                          Momento da coleta: {{ indicator.timeOfCollection }}<br />
                          Valor do IBE/SC: {{ indicator.valueIbeSC }}<br />
                          Observações: {{ indicator.observation }}<br />
                        </p>
                      </div>
                    </div>

                    <div v-if='item.complementaryExamsAcgih && row === complementaryExamsAcgih'>
                      <div
                        class='mt-3'
                        :class="indicatorsIndex < item.complementaryExamsAcgih.indicators.length - 1 ? 'border-supplementaryExamData':''"
                        v-for='(indicator, indicatorsIndex) in item.complementaryExamsAcgih.indicators'
                        :key='indicatorsIndex'>
                        <p>
                          Determinante: {{ indicator[`determining_0${(indicatorsIndex + 1)}`].join(', ') }} <br />
                          Horário da coleta: {{ indicator.timeOfCollection }}<br />
                          <span class='position-relative bei'>BEI<span class='position-absolute mr-2 marca_registrada'> &reg; </span></span>:
                          {{ indicator.valueIbe }}<br />
                          Notações: {{ indicator.notations }}<br />
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <tr v-else :key='`chem_fallback_${item.legalSearchId || item.cas}`'>
                <td>
                  <b-tooltip
                    :target='`chem_${item.cas}_${item.legalSearchId}`'
                    custom-class="custom-tooltip"
                    placement='auto'
                    triggers='hover'
                  >
                    <section
                      v-if='(item.attachment11 && item.attachment11.group) || item.nameAttachment11'
                    >
                      <span class='p-2 text-white' style='font-size: 15px'>
                        Este agente consta na NR 15 com o seguinte nome:
                        {{ item.attachment11 && item.attachment11.group
                          ? item.attachment11.group
                          : item.nameAttachment11 ? item.nameAttachment11: '-' }}
                      </span> <br/><br/>
                    </section>

                    <section class='p-2' v-if='item.acgih && item.agent'>
                      <span class='text-white' style='font-size: 15px'>
                        Este agente já foi citado na ACGIH com o nome:
                        {{ item.agent ? item.agent : '-' }}
                      </span>
                      <br/><br/>
                    </section>

                    <a
                      :href='`https://pubchem.ncbi.nlm.nih.gov/#query=${item.cas}`'
                      target='_blank'
                      class='link-pubchem-cas ml-2'
                    >
                      <span>
                        Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{item.cas}}
                      </span>
                    </a>
                  </b-tooltip>

                  <a href='#' class='hover_links' :id='`chem_${item.cas}_${item.legalSearchId}`'>
                    <span class='word-break'>{{ model.getsearchId(item) }}</span>
                    <b-icon
                      style='margin-bottom: -1px'
                      class='ml-1'
                      font-scale="1.2"
                      icon="info-circle-fill"
                      variant="info"
                    >
                    </b-icon>
                  </a>

                  <section v-if='item.videosOrientacaoAbaPcmso && item.videosOrientacaoAbaPcmso.length > 0'>
                    <button
                      class='btn-orientations mt-2'
                      @click='showModalOrientationVideos(model.getsearchId(item), item.videosOrientacaoAbaLaudoInsalubridade)'
                    >
                      <span>Ver orientações <br/> especificas</span>
                    </button>
                  </section>
                </td>

                <td colspan='2'>
                  É possível que este agente não tenha nenhuma relação com a NR 07 e com a ACGIH para fins de exames
                  complementares.
                  Nossa base de dados é constantemente atualizada e validada para a verificação da inclusão de novas
                  substâncias.
                  A exclusão analítica deste agente e seus possíveis exames no PCMSO fica a cargo do Médico responsável.
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </section>
      </section>

      <!-- ============ RISCOS FÍSICOS ============ -->
      <section v-if="agentWithoutProduct.riskType === 'fisico'">
        <section class='risk-physical d-flex align-items-center justify-content-center pt-3 text-center w-100'>
          <h6><strong>Agentes pesquisados sem vínculo de produto ou cargo.</strong></h6>
        </section>
        <section class='risk-physical d-flex align-items-center justify-content-between margin-top-2 px-3 py-2'>
          <section>
            <strong class='risk-text'>Riscos Físicos</strong>
          </section>
          <section>
            <button class='btn-expand-collapse-navy-blue' @click="toggleChemicalExpanded('tabPcmsoPhysicalRiskOpenAgentsWithoutProductAffiliation')">
              {{ userPreferences && userPreferences.tabPcmsoPhysicalRiskOpenAgentsWithoutProductAffiliation ? 'Recolher informações' : 'Expandir informações' }}
            </button>
          </section>
        </section>
        <section class="margin-left-25">
          <table
            v-if='userPreferences && userPreferences.tabPcmsoPhysicalRiskOpenAgentsWithoutProductAffiliation'
            class='text-center table b-table table-bordered custom-table margin-top-1'
          >
            <thead>
              <tr class='header-table-physical'>
                <th class='width-40-percent'>CAS: Agente</th>
                <th class='width-30-percent'>Origem da informação</th>
                <th class='width-30-percent'>Dados do Exame Complementar</th>
              </tr>
            </thead>

            <tbody>
            <template v-for='item in agentWithoutProduct.legalSearches'>
              <template v-if='item.board_01 || item.board_02 || item.complementaryExamsAcgih'>
                <tr v-for='(row, i) in model.getList(item)' :key='`phys_row_${row}_${item.legalSearchId || item.cas}`'>
                  <td v-if='i === 0' :rowspan='model.getList(item).length'>
                    <div>
                      <b-tooltip
                        :target='`phys_${item.cas}_${item.legalSearchId}`'
                        custom-class="custom-tooltip"
                        placement='auto'
                        triggers='hover'
                      >
                        <section
                          v-if='(item.attachment11 && item.attachment11.group) || item.nameAttachment11'
                        >
                          <span class='p-2 text-white' style='font-size: 15px'>
                            Este agente consta na NR 15 com o seguinte nome:
                            {{ item.attachment11 && item.attachment11.group
                              ? item.attachment11.group
                              : item.nameAttachment11 ? item.nameAttachment11: '-' }}
                          </span> <br/><br/>
                        </section>

                        <section class='p-2' v-if='item.acgih && item.agent'>
                          <span class='text-white' style='font-size: 15px'>
                            Este agente já foi citado na ACGIH com o nome:
                            {{ item.agent ? item.agent : '-' }}
                          </span>
                          <br/><br/>
                        </section>

                        <a
                          :href='`https://pubchem.ncbi.nlm.nih.gov/#query=${item.cas}`'
                          target='_blank'
                          class='link-pubchem-cas ml-2'
                        >
                          <span>
                            Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{item.cas}}
                          </span>
                        </a>
                      </b-tooltip>

                      <a href='#' class='hover_links' :id='`phys_${item.cas}_${item.legalSearchId}`'>
                        <span class='word-break'>{{ model.getsearchId(item) }}</span>
                        <b-icon
                          style='margin-bottom: -1px'
                          class='ml-1'
                          font-scale="1.2"
                          icon="info-circle-fill"
                          variant="info"
                        >
                        </b-icon>
                      </a>

                      <section v-if='item.videosOrientacaoAbaPcmso && item.videosOrientacaoAbaPcmso.length > 0'>
                        <button
                          class='btn-orientations mt-2'
                          @click='showModalOrientationVideos(model.getsearchId(item), item.videosOrientacaoAbaLaudoInsalubridade)'
                        >
                          <span>Ver orientações <br/> especificas</span>
                        </button>
                      </section>
                    </div>
                  </td>
                  <td>
                    <div v-if='item.board_01 && row === board_01'>NR 7 - Quadro 1</div>
                    <div v-if='item.board_02 && row === board_02'>NR 7 - Quadro 2</div>
                    <div v-if='item.complementaryExamsAcgih && row === complementaryExamsAcgih'>ACGIH 2024</div>
                  </td>
                  <td>
                    <div v-if='item.board_01 && row === board_01'>
                      <div
                        class='mt-3'
                        :class="indicatorsIndex < item.board_01.indicators.length - 1 ? 'border-supplementaryExamData':''"
                        v-for='(indicator, indicatorsIndex) in item.board_01.indicators' :key='indicatorsIndex'
                      >
                        <p>
                          Indicador: {{ indicator[`indicator_0${(indicatorsIndex + 1)}`].join(', ') }} <br />
                          Momento da coleta: {{ indicator.timeOfCollection }}<br />
                          Valor do IBE/EE: {{ indicator.valueIbeEE }}<br />
                          Observações: {{ indicator.observation }}<br />
                        </p>
                      </div>
                    </div>

                    <div v-if='item.board_02 && row === board_02'>
                      <div
                        class='mt-3'
                        :class="indicatorsIndex < item.board_02.indicators.length - 1 ? 'border-supplementaryExamData':''"
                        v-for='(indicator, indicatorsIndex) in item.board_02.indicators' :key='indicatorsIndex'
                      >
                        <p>
                          Indicador: {{ indicator[`indicator_0${(indicatorsIndex + 1)}`].join(', ') }} <br />
                          Momento da coleta: {{ indicator.timeOfCollection }}<br />
                          Valor do IBE/SC: {{ indicator.valueIbeSC }}<br />
                          Observações: {{ indicator.observation }}<br />
                        </p>
                      </div>
                    </div>

                    <div v-if='item.complementaryExamsAcgih && row === complementaryExamsAcgih'>
                      <div
                        class='mt-3'
                        :class="indicatorsIndex < item.complementaryExamsAcgih.indicators.length - 1 ? 'border-supplementaryExamData':''"
                        v-for='(indicator, indicatorsIndex) in item.complementaryExamsAcgih.indicators'
                        :key='indicatorsIndex'>
                        <p>
                          Determinante: {{ indicator[`determining_0${(indicatorsIndex + 1)}`].join(', ') }} <br />
                          Horário da coleta: {{ indicator.timeOfCollection }}<br />
                          <span class='position-relative bei'>BEI<span class='position-absolute mr-2 marca_registrada'> &reg; </span></span>:
                          {{ indicator.valueIbe }}<br />
                          Notações: {{ indicator.notations }}<br />
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <tr v-else :key='`phys_fallback_${item.legalSearchId || item.cas}`'>
                <td>
                  <b-tooltip
                    :target='`phys_${item.cas}_${item.legalSearchId}`'
                    custom-class="custom-tooltip"
                    placement='auto'
                    triggers='hover'
                  >
                    <section
                      v-if='(item.attachment11 && item.attachment11.group) || item.nameAttachment11'
                    >
                      <span class='p-2 text-white' style='font-size: 15px'>
                        Este agente consta na NR 15 com o seguinte nome:
                        {{ item.attachment11 && item.attachment11.group
                          ? item.attachment11.group
                          : item.nameAttachment11 ? item.nameAttachment11: '-' }}
                      </span> <br/><br/>
                    </section>

                    <section class='p-2' v-if='item.acgih && item.agent'>
                      <span class='text-white' style='font-size: 15px'>
                        Este agente já foi citado na ACGIH com o nome:
                        {{ item.agent ? item.agent : '-' }}
                      </span>
                      <br/><br/>
                    </section>

                    <a
                      :href='`https://pubchem.ncbi.nlm.nih.gov/#query=${item.cas}`'
                      target='_blank'
                      class='link-pubchem-cas ml-2'
                    >
                      <span>
                        Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{item.cas}}
                      </span>
                    </a>
                  </b-tooltip>

                  <a href='#' class='hover_links' :id='`phys_${item.cas}_${item.legalSearchId}`'>
                    <span class='word-break'>{{ model.getsearchId(item) }}</span>
                    <b-icon
                      style='margin-bottom: -1px'
                      class='ml-1'
                      font-scale="1.2"
                      icon="info-circle-fill"
                      variant="info"
                    >
                    </b-icon>
                  </a>

                  <section v-if='item.videosOrientacaoAbaPcmso && item.videosOrientacaoAbaPcmso.length > 0'>
                    <button
                      class='btn-orientations mt-2'
                      @click='showModalOrientationVideos(model.getsearchId(item), item.videosOrientacaoAbaLaudoInsalubridade)'
                    >
                      <span>Ver orientações <br/> especificas</span>
                    </button>
                  </section>
                </td>

                <td colspan='2'>
                  É possível que este agente não tenha nenhuma relação com a NR 07 e com a ACGIH para fins de exames
                  complementares.
                  Nossa base de dados é constantemente atualizada e validada para a verificação da inclusão de novas
                  substâncias.
                  A exclusão analítica deste agente e seus possíveis exames no PCMSO fica a cargo do Médico responsável.
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </section>
      </section>

      <!-- ============ RISCOS BIOLÓGICOS ============ -->
      <section v-if="agentWithoutProduct.riskType === 'biologico'">
        <section class='risk-biological d-flex align-items-center justify-content-center pt-3 text-center w-100'>
          <h6><strong>Agentes pesquisados sem vínculo de produto ou cargo.</strong></h6>
        </section>
        <section class='risk-biological d-flex align-items-center justify-content-between margin-top-2 px-3 py-2'>
          <section>
            <strong class='risk-text'>Riscos Biológicos</strong>
          </section>
          <section>
            <button class='btn-expand-collapse-navy-blue' @click="toggleChemicalExpanded('tabPcmsoBiologicalRiskOpenAgentsWithoutProductAffiliation')">
              {{ userPreferences && userPreferences.tabPcmsoBiologicalRiskOpenAgentsWithoutProductAffiliation ? 'Recolher informações' : 'Expandir informações' }}
            </button>
          </section>
        </section>
        <section class="margin-left-25">
          <table
            v-if='userPreferences && userPreferences.tabPcmsoBiologicalRiskOpenAgentsWithoutProductAffiliation'
            class='text-center table b-table table-bordered custom-table margin-top-1'
          >
            <thead>
              <tr class='header-table-biological'>
                <th class='width-40-percent'>CAS: Agente</th>
                <th class='width-30-percent'>Origem da informação</th>
                <th class='width-30-percent'>Dados do Exame Complementar</th>
              </tr>
            </thead>

            <tbody>
            <template v-for='item in agentWithoutProduct.legalSearches'>
              <template v-if='item.board_01 || item.board_02 || item.complementaryExamsAcgih'>
                <tr v-for='(row, i) in model.getList(item)' :key='`bio_row_${row}_${item.legalSearchId || item.cas}`'>
                  <td v-if='i === 0' :rowspan='model.getList(item).length'>
                    <div>
                      <b-tooltip
                        :target='`bio_${item.cas}_${item.legalSearchId}`'
                        custom-class="custom-tooltip"
                        placement='auto'
                        triggers='hover'
                      >
                        <section
                          v-if='(item.attachment11 && item.attachment11.group) || item.nameAttachment11'
                        >
                          <span class='p-2 text-white' style='font-size: 15px'>
                            Este agente consta na NR 15 com o seguinte nome:
                            {{ item.attachment11 && item.attachment11.group
                              ? item.attachment11.group
                              : item.nameAttachment11 ? item.nameAttachment11: '-' }}
                          </span> <br/><br/>
                        </section>

                        <section class='p-2' v-if='item.acgih && item.agent'>
                          <span class='text-white' style='font-size: 15px'>
                            Este agente já foi citado na ACGIH com o nome:
                            {{ item.agent ? item.agent : '-' }}
                          </span>
                          <br/><br/>
                        </section>

                        <a
                          :href='`https://pubchem.ncbi.nlm.nih.gov/#query=${item.cas}`'
                          target='_blank'
                          class='link-pubchem-cas ml-2'
                        >
                          <span>
                            Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{item.cas}}
                          </span>
                        </a>
                      </b-tooltip>

                      <a href='#' class='hover_links' :id='`bio_${item.cas}_${item.legalSearchId}`'>
                        <span class='word-break'>{{ model.getsearchId(item) }}</span>
                        <b-icon
                          style='margin-bottom: -1px'
                          class='ml-1'
                          font-scale="1.2"
                          icon="info-circle-fill"
                          variant="info"
                        >
                        </b-icon>
                      </a>

                      <section v-if='item.videosOrientacaoAbaPcmso && item.videosOrientacaoAbaPcmso.length > 0'>
                        <button
                          class='btn-orientations mt-2'
                          @click='showModalOrientationVideos(model.getsearchId(item), item.videosOrientacaoAbaLaudoInsalubridade)'
                        >
                          <span>Ver orientações <br/> especificas</span>
                        </button>
                      </section>
                    </div>
                  </td>
                  <td>
                    <div v-if='item.board_01 && row === board_01'>NR 7 - Quadro 1</div>
                    <div v-if='item.board_02 && row === board_02'>NR 7 - Quadro 2</div>
                    <div v-if='item.complementaryExamsAcgih && row === complementaryExamsAcgih'>ACGIH 2024</div>
                  </td>
                  <td>
                    <div v-if='item.board_01 && row === board_01'>
                      <div
                        class='mt-3'
                        :class="indicatorsIndex < item.board_01.indicators.length - 1 ? 'border-supplementaryExamData':''"
                        v-for='(indicator, indicatorsIndex) in item.board_01.indicators' :key='indicatorsIndex'
                      >
                        <p>
                          Indicador: {{ indicator[`indicator_0${(indicatorsIndex + 1)}`].join(', ') }} <br />
                          Momento da coleta: {{ indicator.timeOfCollection }}<br />
                          Valor do IBE/EE: {{ indicator.valueIbeEE }}<br />
                          Observações: {{ indicator.observation }}<br />
                        </p>
                      </div>
                    </div>

                    <div v-if='item.board_02 && row === board_02'>
                      <div
                        class='mt-3'
                        :class="indicatorsIndex < item.board_02.indicators.length - 1 ? 'border-supplementaryExamData':''"
                        v-for='(indicator, indicatorsIndex) in item.board_02.indicators' :key='indicatorsIndex'
                      >
                        <p>
                          Indicador: {{ indicator[`indicator_0${(indicatorsIndex + 1)}`].join(', ') }} <br />
                          Momento da coleta: {{ indicator.timeOfCollection }}<br />
                          Valor do IBE/SC: {{ indicator.valueIbeSC }}<br />
                          Observações: {{ indicator.observation }}<br />
                        </p>
                      </div>
                    </div>

                    <div v-if='item.complementaryExamsAcgih && row === complementaryExamsAcgih'>
                      <div
                        class='mt-3'
                        :class="indicatorsIndex < item.complementaryExamsAcgih.indicators.length - 1 ? 'border-supplementaryExamData':''"
                        v-for='(indicator, indicatorsIndex) in item.complementaryExamsAcgih.indicators'
                        :key='indicatorsIndex'>
                        <p>
                          Determinante: {{ indicator[`determining_0${(indicatorsIndex + 1)}`].join(', ') }} <br />
                          Horário da coleta: {{ indicator.timeOfCollection }}<br />
                          <span class='position-relative bei'>BEI<span class='position-absolute mr-2 marca_registrada'> &reg; </span></span>:
                          {{ indicator.valueIbe }}<br />
                          Notações: {{ indicator.notations }}<br />
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <tr v-else :key='`bio_fallback_${item.legalSearchId || item.cas}`'>
                <td>
                  <b-tooltip
                    :target='`bio_${item.cas}_${item.legalSearchId}`'
                    custom-class="custom-tooltip"
                    placement='auto'
                    triggers='hover'
                  >
                    <section
                      v-if='(item.attachment11 && item.attachment11.group) || item.nameAttachment11'
                    >
                      <span class='p-2 text-white' style='font-size: 15px'>
                        Este agente consta na NR 15 com o seguinte nome:
                        {{ item.attachment11 && item.attachment11.group
                          ? item.attachment11.group
                          : item.nameAttachment11 ? item.nameAttachment11: '-' }}
                      </span> <br/><br/>
                    </section>

                    <section class='p-2' v-if='item.acgih && item.agent'>
                      <span class='text-white' style='font-size: 15px'>
                        Este agente já foi citado na ACGIH com o nome:
                        {{ item.agent ? item.agent : '-' }}
                      </span>
                      <br/><br/>
                    </section>

                    <a
                      :href='`https://pubchem.ncbi.nlm.nih.gov/#query=${item.cas}`'
                      target='_blank'
                      class='link-pubchem-cas ml-2'
                    >
                      <span>
                        Clique <strong>aqui</strong> para ver a imagem da estrutura molecular do agente químico {{item.cas}}
                      </span>
                    </a>
                  </b-tooltip>

                  <a href='#' class='hover_links' :id='`bio_${item.cas}_${item.legalSearchId}`'>
                    <span class='word-break'>{{ model.getsearchId(item) }}</span>
                    <b-icon
                      style='margin-bottom: -1px'
                      class='ml-1'
                      font-scale="1.2"
                      icon="info-circle-fill"
                      variant="info"
                    >
                    </b-icon>
                  </a>

                  <section v-if='item.videosOrientacaoAbaPcmso && item.videosOrientacaoAbaPcmso.length > 0'>
                    <button
                      class='btn-orientations mt-2'
                      @click='showModalOrientationVideos(model.getsearchId(item), item.videosOrientacaoAbaLaudoInsalubridade)'
                    >
                      <span>Ver orientações <br/> especificas</span>
                    </button>
                  </section>
                </td>

                <td colspan='2'>
                  É possível que este agente não tenha nenhuma relação com a NR 07 e com a ACGIH para fins de exames
                  complementares.
                  Nossa base de dados é constantemente atualizada e validada para a verificação da inclusão de novas
                  substâncias.
                  A exclusão analítica deste agente e seus possíveis exames no PCMSO fica a cargo do Médico responsável.
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </section>
      </section>
    </section>


      <template v-slot:overlay>
        <div class="text-center loading-spinner">
          <b-spinner
            style="width: 2rem; height: 2rem"
            variant="primary"
            label="Large Spinner"
          ></b-spinner>
          <h4 class="text-primary">Buscando...</h4>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import eventBus from '../../../utils/eventBus'
import Pcmso from '@/models/Pcmso'
import TabButtons from '@/components/LegalSearch/components/TabButtons.vue'
import OrientationVideos from '@/components/LegalSearch/Modal/OrientationVideos.vue'

export default {
  name: 'PcmsoTable',
  data() {
    return {
      model: Pcmso,
      board_01: 1,
      board_02: 2,
      complementaryExamsAcgih: 3,
      orientationVideos: [],
      agent: "",
      agentsWithoutProduct: [],
      userPreferencesId: null,
      loading: false,
    }
  },
  components: { OrientationVideos, TabButtons },
  computed: {
    ...mapGetters('userPreferences', {
      userPreferences: 'userPreferences',
    }),
    xlsxLink() {
      return `${process.env.VUE_APP_BASE_URL}/xlsx/${this.user.id}/pcmso`
    },
    summary() {
      return this.$store.getters['legalSearch/summary']
    },
    releaseAcgih() {
      return this.$store.getters['user/releaseAcgih']
    },
    user() {
      return this.$store.getters['user/current']
    }
  },
  methods: {
    ...mapActions('reportsDownloads', {
      handleCreateReportDownloads: 'handleCreateReportDownloads'
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('event', {
      handlGetEventActive: 'handlGetEventActive'
    }),
    ...mapActions('legalSearch', {
      exportingExcel: 'exportingExcel',
      handleGetAgentsWithoutProductPcmso: 'handleGetAgentsWithoutProductPcmso',
    }),
    ...mapActions('userPreferences', {
      handleGetUserPreferences: 'handleGetUserPreferences',
      handleUpdateTabSummaryRiskOpen: 'handleUpdateTabSummaryRiskOpen',
    }),
    async loadTabSummaryRiskPreferences() {
      try {
        await this.handleGetUserPreferences(this.user.id)
        const { _id } = this.userPreferences || {}
        this.userPreferencesId = _id
      } catch (e) {
        //
      }
    },
    async loadAgentsWithoutProductPcmso() {
      const { data } = await this.handleGetAgentsWithoutProductPcmso(this.user.id)
      const { items } = data || {}
      this.agentsWithoutProduct = items || []
    },
    async toggleChemicalExpanded(field) {
      try {
        this.loading = true
        await this.handleUpdateTabSummaryRiskOpen({
          _id: this.userPreferencesId,
          [field]: !this.userPreferences[field]
        })
        await this.handleGetUserPreferences(this.user.id)
        this.loading = false
      } catch (e) {
        console.log(e)
      }
    },
    showModalOrientationVideos(agent, orientationVideos){
      this.orientationVideos = orientationVideos
      this.agent = agent
      setTimeout(() => {
        this.$bvModal.show('orientationVideos')
      },100)
    }

  },
  async mounted() {
    this.loading = true
    await this.loadTabSummaryRiskPreferences()
    await this.loadAgentsWithoutProductPcmso()
    this.loading = false
    eventBus.$on('reloadLegalSearchReportTabs', async () => {
      await this.loadAgentsWithoutProductPcmso()
    })
  },
  beforeDestroy() {
    eventBus.$off('generateReportInsalubrity')
    eventBus.$off('reloadLegalSearchReportTabs')
  },
  created() {
  }
}
</script>

<style scoped>
.margin-left-25{
  margin-left: 25px;
}
.icon {
  cursor: pointer;
  margin-left: 7px;
}

.hover_links {
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 24px;
  color: #04A8F3;
  cursor: pointer;
}

.hover_links:hover {
  text-decoration: underline;
}

.sticky {
  position: sticky;
  top: 10px;
  z-index: 10;
}

.container-tab-buttons {
  padding: 0 0 5px 0 !important;
}

.headerTable {
  vertical-align: middle;
  background: #94D5F3;
  padding: 10px;
  top: 50px;
}

.header-table-chemical {
  vertical-align: middle;
  background: #04A8F366!important;
}
.header-table-chemical th {
  vertical-align: middle;
  background: #04A8F366!important;
}

.header-table-physical {
  vertical-align: middle;
  background: #CCE5D2;
}
.header-table-physical th {
  vertical-align: middle;
  background: #CCE5D2!important;
}

.header-table-biological {
  vertical-align: middle;
  background: #E3BEB0!important;
}
.header-table-biological th {
  vertical-align: middle;
  background: #E3BEB0!important;
}

.width-20-percent {
  width: 20% !important;
}
.width-40-percent {
  width: 40% !important;
}
.width-30-percent {
  width: 30% !important;
}

.border-supplementaryExamData {
  border-bottom: 1px solid #ccc;
}

td {
  vertical-align: middle;
}

.field_ps {
  text-align: left;
  font-size: 12px;
}

.marca_registrada {
  font-size: 14px;
}

.bei {
  margin-right: 12px;
}

.risk-chemical {
  background: rgba(4, 168, 243, 0.4) !important;
  margin-top: 1px;
}

.risk-physical {
  background: #CCE5D2 !important;
  margin-top: 8px;
}

.risk-biological {
  background: #E3BEB0 !important;
  margin-top: 8px;
}

.risk-text {
  font-weight: 700;
  font-size: 16px;
  color: #262626;
}

.btn-expand-collapse-navy-blue {
  background: transparent;
  border: 1px solid #022245;
  border-radius: 6.25px;
  font-weight: 600;
  padding: 10px;
}
.margin-top-1 {
  margin-top: 1px;
}
.margin-top-2 {
  margin-top: 2px;
}
</style>
